// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Medal20CircleProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Medal20Circle: FC<Medal20CircleProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0Zm0 4c-1.667 0-3.083.595-4.25 1.784C6.583 6.974 6 8.418 6 10.117c0 .824.167 1.641.5 2.451.333.81.776 1.458 1.327 1.942V20L12 19.059l4.154.941v-5.472c.616-.495 1.076-1.146 1.384-1.95a6.835 6.835 0 0 0 .462-2.46c0-1.7-.583-3.144-1.75-4.334C15.083 4.594 13.667 4 12 4Zm2.77 14.235L12 17.607l-2.788.628V15.53c.423.249.871.428 1.346.54.474.11.955.166 1.442.166s.965-.059 1.433-.176a5.497 5.497 0 0 0 1.337-.53v2.706ZM12 5.412c1.282 0 2.372.457 3.27 1.372.897.915 1.345 2.026 1.345 3.333 0 1.307-.448 2.42-1.345 3.334-.898.915-1.988 1.372-3.27 1.372s-2.372-.457-3.27-1.372c-.897-.915-1.345-2.027-1.345-3.334S7.833 7.7 8.73 6.784c.898-.915 1.988-1.372 3.27-1.372Zm0 2.353c-.641 0-1.186.229-1.635.686a2.292 2.292 0 0 0-.673 1.666c0 .654.225 1.21.673 1.667.449.458.994.687 1.635.687s1.186-.23 1.635-.687a2.293 2.293 0 0 0 .673-1.667c0-.653-.225-1.208-.673-1.666A2.205 2.205 0 0 0 12 7.765Z" />
        </svg>
    );
};

export default Medal20Circle;
